var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.305 31.8a1.085 1.085 0 001.4-.119L31.68 17.705c.377-.375.427-.967.119-1.4a5.441 5.441 0 010-6.304c.31-.433.259-1.026-.119-1.401L25.4 2.319a1.087 1.087 0 00-1.403-.119 5.441 5.441 0 01-6.302 0 1.088 1.088 0 00-1.4.119L2.32 16.295a1.088 1.088 0 00-.12 1.4 5.441 5.441 0 010 6.304 1.085 1.085 0 00.12 1.401l6.28 6.281c.375.376.968.426 1.4.116a5.442 5.442 0 016.305.003z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.062 7.705a1 1 0 011.415 0l7.817 7.818a1 1 0 010 1.414l-9.356 9.357a1 1 0 01-1.414 0l-7.818-7.818a1 1 0 010-1.414l9.356-9.357z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.77 13.153l-4.617 4.616M19.372 17.705l-1.437 1.438",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTickets;